// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--23I4g";
export var footer__container = "footer-module--footer__container--1t-gv";
export var footer__container__address = "footer-module--footer__container__address--3GMgL";
export var footer__container__address__contact = "footer-module--footer__container__address__contact--1NnNQ";